class ProductBenefits {
  static FADE_DURATION_MS = 250;

  constructor(container) {
    this.container = container;
    this.benefits = container.querySelectorAll('.main-product__product-benefit');
    this.sectionId = container.dataset.section;

    this.updateVisibility = this.updateVisibility.bind(this);
    this.init();
  }

  getVariantPicker() {
    return (
      document.querySelector(`variant-selects[data-section="${this.sectionId}"]`) ||
      document.querySelector(`variant-radios[data-section="${this.sectionId}"]`)
    );
  }

  init() {
    if (!this.benefits.length) return;

    this.getVariantPicker()?.addEventListener('change', this.updateVisibility);

    const variantIdInput = document.querySelector(
      `#product-form-${this.sectionId} input[name="id"]`
    );
    variantIdInput?.addEventListener('change', this.updateVisibility);

    this.updateVisibility();
  }

  getSelectedOptions() {
    const options = {};
    const variantPicker = this.getVariantPicker();
    if (!variantPicker) return options;

    variantPicker.querySelectorAll('select[name^="options["]').forEach((select) => {
      const match = select.name.match(/options\[(.+)\]/);
      if (match) {
        options[match[1].toLowerCase()] = select.value.toLowerCase().trim();
      }
    });

    variantPicker.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
      if (radio.name && !radio.name.startsWith('options[')) {
        options[radio.name.toLowerCase()] = radio.value.toLowerCase().trim();
      }
    });

    return options;
  }

  shouldShowBenefit(benefit, selectedOptions) {
    const key = benefit.dataset.benefitKey;
    const value = benefit.dataset.benefitValue;

    if (key === 'product') return true;
    return selectedOptions[key] === value;
  }

  clearHideFallback(benefit) {
    if (benefit._hideFallback) {
      clearTimeout(benefit._hideFallback);
      benefit._hideFallback = null;
    }
  }

  showBenefit(benefit) {
    if (benefit.classList.contains('is-visible')) return;

    this.clearHideFallback(benefit);
    if (benefit._onHideTransitionEnd) {
      benefit.removeEventListener('transitionend', benefit._onHideTransitionEnd);
      benefit._onHideTransitionEnd = null;
    }

    benefit.classList.remove('is-collapsed');
    requestAnimationFrame(() => {
      benefit.classList.add('is-visible');
    });
  }

  hideBenefit(benefit) {
    if (benefit.classList.contains('is-collapsed')) return;

    if (!benefit.classList.contains('is-visible')) {
      benefit.classList.add('is-collapsed');
      return;
    }

    this.clearHideFallback(benefit);
    benefit.classList.remove('is-visible');

    const onTransitionEnd = (event) => {
      if (event.target !== benefit || event.propertyName !== 'opacity') return;
      benefit.removeEventListener('transitionend', onTransitionEnd);
      benefit._onHideTransitionEnd = null;

      if (!benefit.classList.contains('is-visible')) {
        benefit.classList.add('is-collapsed');
      }
    };

    benefit._onHideTransitionEnd = onTransitionEnd;
    benefit.addEventListener('transitionend', onTransitionEnd);

    benefit._hideFallback = setTimeout(() => {
      benefit._hideFallback = null;
      if (!benefit.classList.contains('is-visible')) {
        benefit.classList.add('is-collapsed');
      }
    }, ProductBenefits.FADE_DURATION_MS);
  }

  updateVisibility() {
    const selectedOptions = this.getSelectedOptions();

    this.benefits.forEach((benefit) => {
      const show = this.shouldShowBenefit(benefit, selectedOptions);

      if (show) {
        this.showBenefit(benefit);
      } else {
        this.hideBenefit(benefit);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.main-product__product-benefits').forEach((container) => {
    new ProductBenefits(container);
  });
});
